<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">Management Dashboard</h1>
        <p class="subheading font-weight-regular">View organizations, manage users, and more.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">Select you organization</h2>
        <UserToCompany :user="store.user" :organizations="organizations" :canDelete="false" @updateOrgainzationForUser="updateOrganizationFromSignedInUser"/>
      </v-col>

      <v-col class="mb-5" cols="12">
        <v-layout row wrap>
          <h2 class="headline font-weight-bold mb-3">Manage Philippines Team</h2>
          <v-btn class="ml-3" text icon color="primary" @click="addOperatorDialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-layout>
        <UserToCompany
          v-for="operator in store.operators"
          :key="operator.email"
          :user="operator" :organizations="organizations" :canDelete="true"
          @deleteUser="confirmDeleteOperator"
          @updateOrgainzationForUser="updateOrganizationFromOperator"/>
      </v-col>
      <NewUserDialog v-model="addOperatorDialog" text="Add a new Philippines team member" :width="500" @input="addOperator"/>
      <v-dialog v-model="areYouSureDeleteOperatorDialog" width="500">
      <v-card>
        <v-card-text>Are you sure to delete the Philippines team member?</v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="deleteOperator">Yes</v-btn>
            <v-btn color="primary" text @click="areYouSureDeleteOperatorDialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <NewOrgDialog v-model="addOrgDialog" text="Create a new organization" :width="500" @input="addOrganization"/>
      <v-col class="mb-5" cols="12">
        <v-layout row wrap>
          <h2 class="headline font-weight-bold mb-3">All Organizations</h2>
          <v-btn class="ml-3" text icon color="primary" @click="addOrgDialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-layout>
        <v-row justify="center">
          <v-expansion-panels popout>
            <v-expansion-panel v-for="(organization, i) in store.organizations" :key="i">
              <v-expansion-panel-header>{{ organization.name }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout column>
                  <v-flex xs9 sm7 md5 lg4 mr-1>
                    <p>Organization ID: {{ organization.id }}</p>
                  </v-flex>
                  <v-layout>
                    <v-flex xs9 sm7 md5 lg4 mr-1>
                      <v-text-field color="primary" outlined :items="organizations" label="Landscape Export Sheet" v-model="organization.sheets.landscapeExport"/>
                    </v-flex>
                    <v-flex xs9 sm7 md5 lg4 mr-1>
                      <v-text-field color="primary" outlined :items="organizations" label="Portrait Export Sheet" v-model="organization.sheets.portraitExport"/>
                    </v-flex>
                    <v-flex xs9 sm7 md5 lg4 mr-1>
                      <v-text-field color="primary" outlined :items="organizations" label="Delta Export Sheet" v-model="organization.sheets.deltaExport"/>
                    </v-flex>
                    <v-btn class="pt-5 pb-5 pt-9 pl-8 pr-8 ml-3" dark color="primary" @click="updateOrganization(organization)">
                      <p>Save</p>
                    </v-btn>
                  </v-layout>
                  <!-- <v-layout>
                    <v-btn class="pt-5 pb-5 pt-9 pl-8 pr-8 ml-3" dark color="primary">
                      <p>Add member</p>
                    </v-btn>
                  </v-layout>-->
                </v-layout>
                <!-- <p>Team Members</p> -->
                <!-- <ul><li v-for="member in organization.users" :key="member.email">{{ member.name }} ({{ member.email }})</li></ul> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import UserToCompany from './UserToCompany'
import NewUserDialog from './NewUserDialog'
import NewOrgDialog from './NewOrgDialog'
export default {
  name: 'Dashboard',
  components: { UserToCompany, NewUserDialog, NewOrgDialog },
  data: () => ({
    organizations: [],
    areYouSureDeleteOperatorDialog: false,
    addOperatorDialog: false,
    addOrgDialog: false,
    operatorToDelete: ''
  }),
  methods: {
    addOrganization (organization) {
      if (typeof organization !== 'undefined') {
        this.addOrgDialog = false
        this.$store.dispatch('createOrganization', organization)
      }
    },
    updateOrganization (organization) {
      this.organizationEditable = false
      this.$store.dispatch('updateOrganization', organization)
    },
    addOrgToUser (user) {
      this.store.organizations.filter(o => o.name === user.organizationName)
        .forEach(o => { user.organization = o.id })
    },
    updateOrganizationFromSignedInUser (user) {
      this.addOrgToUser(user)
      this.$store.dispatch('updateOrganizationFromSignedInUser', user)
    },
    updateOrganizationFromOperator (user) {
      this.addOrgToUser(user)
      this.$store.dispatch('updateOrganizationFromOperator', user)
    },
    addOperator (email) {
      if (typeof email !== 'undefined') {
        this.addOperatorDialog = false
        this.$store.dispatch('addOperator', { name: '', email, organization: '' })
      }
    },
    confirmDeleteOperator (operator) {
      this.operatorToDelete = operator
      this.areYouSureDeleteOperatorDialog = true
    },
    deleteOperator () {
      this.areYouSureDeleteOperatorDialog = false
      this.$store.dispatch('deleteOperator', this.operatorToDelete)
    }
  },
  async created () {
    await this.$store.dispatch('getUsers')
    await this.$store.dispatch('getOrganizations')
    await this.$store.dispatch('getOperators')
    this.store.organizations.forEach(organization => {
      this.organizations.push(organization.name)
    })
    await this.$store.dispatch('getLatestUser', this.store.user)
  },
  computed: {
    ...mapState(['store'])
  }
}
</script>
